/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-05-07 16:03:18
 * @FilePath: \client-h5\src\pages\bindTel\services.js
 */
import http from '../../utils/http';
/**
 * 验证码
 */
 export function getCode(params) {
  return http("get", '/login/sendSms',params);
}
/**
 * 注册
 */
export function register(params) {
  return http("post", '/login/register',params);
}


//换绑手机
export function changePhone(params) {
  return http("put", '/my/changePhone?newPhone='+params.telephone+'&code='+params.code);
}

//确认换绑微信
export function comfirmChangePhone(params) {
  return http("put", '/login/bind/confirm?openid='+params.openid+'&telephone='+params.telephone);
}


